import planPageMessages from 'pages/MainPage/PlanPage/messages';

export function calcfreestandingHobMeasurementsError(freestandingHobs, sides, defaultWidth, usingImperial) {
  if (!freestandingHobs || freestandingHobs.get('value') <= 0) return [];
  let width = freestandingHobs.get('width');
  let min;
  min = 0;
  if (width !== null && width <= min) {
    return [{
      ...(
        usingImperial 
        ? planPageMessages.errorMinimumImperial
        : planPageMessages.errorMinimum
      ),
      values: {
        value: 1,
      },
    },
    ];
  }
  const errors = calculateFreestandingHobShapeMeasurementError(freestandingHobs, sides, defaultWidth).map((error) => {
    return error.message;
  });

  return errors;
}

export function calculateFreestandingHobShapeMeasurementError(freestandingHobs, sides, defaultWidth) {
  const errors = [];
  const invalidLengths = [];
  const width = freestandingHobs.get('width') || defaultWidth;

  if (sides) {
    const invalid = sides.map((side) => {
      const invalidLength = side.length.value <= width * freestandingHobs.get('value');
      if (invalidLength) {
        invalidLengths.push(side.length.name);
        return true;
      }
      return false;
    });
    if (invalid.every((i) => i)) {
      errors.push({
        fields: invalidLengths,
        message: planPageMessages.errorFreestandingHob,
      });
    }
  }
  return errors;
}
